import Delete from './Delete';
import Button from './Button';
import Link from './Link';

export default {
  Delete,
  Button,
  Link,
};
